import withCounter from '../../../HOC/withTitle';
import NavBtnBase from '../../atoms/NavBtnBase';

export default withCounter(NavBtnBase, true);
